/** URL state of the strategy consolidated report: the scope node and the sections the reader switched off. */
export const REPORT_SECTIONS = ['summary', 'levels', 'kpis', 'schedule', 'issues', 'programs', 'impact', 'beneficiaries'] as const;
export type ReportSection = (typeof REPORT_SECTIONS)[number];

export interface StrategyReportSearch {
  node?: string;
  /** Comma-separated section codes that are hidden (absent = everything shown). */
  hide?: string;
}

export function parseStrategyReportSearch(raw: Record<string, unknown>): StrategyReportSearch {
  const node = typeof raw.node === 'string' && raw.node.trim() ? raw.node : undefined;
  const hide = typeof raw.hide === 'string' ? raw.hide.split(',').filter((s) => (REPORT_SECTIONS as readonly string[]).includes(s)) : [];
  return { node, hide: hide.length ? hide.join(',') : undefined };
}

export const hiddenSections = (search: StrategyReportSearch): Set<ReportSection> => new Set((search.hide ?? '').split(',').filter(Boolean) as ReportSection[]);
